import { ChartInterface } from "@/interface/chart";
import { ChartType } from "@/types/chart";

export class Chart implements ChartInterface {
  series: any;
  options: any;
  priority?: number;
  position?: number;

  constructor(data: ChartType) {
    this.series = data.series;
    this.options = data.options;
    this.priority = data.priority || 0;
    this.position = data.position || 0;
  }
}
